import { mapActions } from "vuex";
export default {
  data: () => ({
    employeeId: "",
  }),
  computed: {},
  methods: {
    ...mapActions("user", ["callForgotPass"]),
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type,
      });
    },
    async sendToEmail() {
      try {
        // await this.callForgotPass({
        //   employeeId: this.employeeId
        // });
        this.notifyVue("success", "Berhasil, kode verifikasi sudah benar");
        this.$router.push({ name: "UpdatePassword" });
      } catch (err) {
        this.notifyVue("danger", err.response.data.error);
      }
    },
  },
  mounted() {},
};
